import React from 'react';
import './index.css';
import { render } from 'react-dom';
import ReactPixel from 'react-facebook-pixel';
import { App } from './App';
ReactPixel.init('784822604691351');
ReactPixel.pageView();
render(<App data-id="element-189" />, document.getElementById('root'));